import React from 'react';
import {ContentTemplate, SectionHeader, Typography} from 'web-library';
import {useTranslation} from 'react-i18next';
import RetrieveAppealRegistrationForm from "./RetrieveAppealRegistrationForm";

const SchoolCandidateAppealPayment = () => {
  const {t} = useTranslation();
  return (<ContentTemplate isContinuable>
    <SectionHeader title={t('components->>SchoolCandidateAppealPayment.CandidateDetails')}/>
    <Typography variant="body1">
      {t('components->>SchoolCandidateAppealPayment.CandidateDetailsInstruction')}
    </Typography>
    <RetrieveAppealRegistrationForm />
  </ContentTemplate>);
};

export default SchoolCandidateAppealPayment;
